import { gql } from '@apollo/client'

// Add new Banner
export const ADD_APP_BANNER = gql`
    mutation CreateAppBanner($appBanner: AppBannerInput!) {
        createAppBanner(app_banner: $appBanner) {
            code
            success
            message
        }
    }
`

// Update Banner
export const UPDATE_APP_BANNER = gql`
    mutation UpdateAppBanner($updateAppBannerId: NonEmptyString!, $appBanner: AppBannerInput!) {
        updateAppBanner(id: $updateAppBannerId, app_banner: $appBanner) {
            code
            success
            message
        }
    }
`

export const ADD_LOCATION = gql`
    mutation AddLocation($location: LocationInput!) {
        addLocation(location: $location) {
            code
            success
            message
        }
    }
`

// Update Banner
export const UPDATE_LOCATION = gql`
    mutation UpdateLocation($location: LocationInput!, $locationId: NonEmptyString!) {
        updateLocation(location: $location, location_id: $locationId) {
            code
            success
            message
        }
    }
`

export const FEEDBACK_ADMIN_ACTION = gql`
    mutation AdminActionFeedbackResponse(
        $adminAction: FeedbackResponseAdminActionInput!
        $responseId: NonEmptyString!
    ) {
        adminActionFeedbackResponse(admin_action: $adminAction, response_id: $responseId) {
            code
            success
            message
        }
    }
`

export const UPDATE_SYSTEM_CONFIG = gql`
    mutation UpdateSystemConfig($settingValue: SystemConfigInput!, $settingName: NonEmptyString!) {
        updateSystemConfig(setting_value: $settingValue, setting_name: $settingName) {
            code
            success
            message
        }
    }
`

export const UPDATE_SERVICE_PAYMENT = gql`
    mutation UpdateServicePayment($serviceCode: NonEmptyString!, $paymentOption: ServicePaymentOptionInput!) {
        updateServicePayment(service_code: $serviceCode, payment_option: $paymentOption) {
            code
            success
            message
        }
    }
`
export const ADD_ROUTE_PRICE_DISCOUNT = gql`
    mutation CreateRoutePriceDiscount($routePriceDiscount: RoutePriceDiscountInput!) {
        createRoutePriceDiscount(route_price_discount: $routePriceDiscount) {
            code
            success
            message
        }
    }
`

export const UPDATE_ROUTE_PRICE_DISCOUNT = gql`
    mutation UpdateRoutePriceDiscount($discountId: NonEmptyString!, $routePriceDiscount: RoutePriceDiscountInput!) {
        updateRoutePriceDiscount(discount_id: $discountId, route_price_discount: $routePriceDiscount) {
            code
            success
            message
        }
    }
`

export const ADD_MEAL = gql`
    mutation AddMeal($meal: MealInput!) {
        addMeal(meal: $meal) {
            code
            success
            message
        }
    }
`

export const UPDATE_MEAL = gql`
    mutation UpdateMeal($mealId: String!, $meal: MealInput!) {
        updateMeal(meal_id: $mealId, meal: $meal) {
            code
            success
            message
        }
    }
`
